import endpointDuckFactory from "./_endpointDuckFactory";

const distributionSitesDuck = endpointDuckFactory({
  endpoint: "distribution-sites",
});

export default distributionSitesDuck;
